import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import axios, {AxiosError} from 'axios';
import {useDispatch} from 'react-redux';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../utils/queryKeys';
import {type TypedTranslation} from '../../i18n';
import {HtmlSlideFile} from '../../utils/htmlSlideImport';
import {startPresUpdateSpinnerAction, stopPresUpdateSpinnerAction} from '../../store/actions/spinner';
import {importHtmlPresentation} from '../presentation';

export const IMPORT_HTML_PRESENTATION_KEY = ['importHtmlPresentation'];

function useImportHtmlPresentation(): UseMutationResult<string, unknown, {slides: HtmlSlideFile[]}, void> {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const {t} = useTranslation();

    return useMutation((args: {slides: HtmlSlideFile[]}) => importHtmlPresentation(args.slides), {
        mutationKey: IMPORT_HTML_PRESENTATION_KEY,
        onMutate: () => {
            dispatch(startPresUpdateSpinnerAction());
        },
        onSettled: () => {
            dispatch(stopPresUpdateSpinnerAction());
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
        },
        onError: (error) => {
            if (axios.isAxiosError(error)) {
                const errorData = (error as AxiosError<{message: string}>).response?.data;

                if (errorData?.message) {
                    toast.error(t(errorData.message as TypedTranslation));
                }
            }
        },
    });
}

export default useImportHtmlPresentation;
